import { ACCESS_TOKEN_KEY } from '@crm/app-constants'

export const useUploadProps = (): {
  name: string
  action: string
  headers: { [key: string]: string }
} => {
  const service = import.meta.env.VITE_APP_FS_API

  if (!service) {
    throw new Error(`Service config missing for FS`)
  }

  const accessToken = window.localStorage.getItem(ACCESS_TOKEN_KEY)

  return {
    name: 'file',
    action: service,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }
}
